<template>
  <OrderOverviewPage
    i18n-prefix="tableOrder"
    config-key="TABLE_ORDER"
    :retrieve-order-options="retrieveOrderOptions"
    :confirm-dialog-message-args-builder="buildConfirmDialogMessageArgs"
    :before-new-order="clearBasketBeforeNewOrder"
  />
</template>

<script>
import OrderOverviewPage from "@/components/page-components/Order/OrderOverviewPage.vue";
import {Order} from "@/constants/constants";
import {useBasketStore} from "@/stores/basket";

export default {
  name: 'TableOrder',
  components: {
    OrderOverviewPage,
  },
  setup() {
    const basketStore = useBasketStore();
    return {
      basketStore,
    };
  },
  data() {
    return {
      retrieveOrderOptions: {
        orderTypeId: Order.orderTypId.DINE_IN,
      },
    };
  },
  methods: {
    buildConfirmDialogMessageArgs({ table }) {
      return [table?.code];
    },
    clearBasketBeforeNewOrder() {
      this.basketStore.clearBasket();
    },
  },
}
</script>
